import axios from "axios"
import {store} from "../store/store"

const axiosInstance = axios.create({
    // baseURL: `http://localhost:4000`
    // baseURL: `https://digitalhire.iqsoft.io`,
    baseURL: `https://api.digitalhire.com`,
})

axiosInstance.interceptors.request.use((config) => {
    const state = store.getState()
    const token = state.auth.auth.token
    config.params = config.params || {}
    config.headers = {
        Authorization: `Bearer ${token}`,
    }
    // config.params["auth"] = token
    return config
})

export default axiosInstance
